import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { IWorkOrderPOProgressModel } from "mobx-stores/_models/work-order-po/progress/work-order-po-progress-base-model";
import { ReactNode } from "react";
import { NumberText } from "share-components/atomics/number-text";
import { EditIconButton } from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
import OrderNumberBadge from "./order-number-badge";

type StandardProcessTableProps = {
  standardTitle: string;
  departmentTitle: string;
  orderNumber: number;
  progress: IWorkOrderPOProgressModel;
  note: string;
  onEdit: () => void;
  editAccessPermission: string[];
  leadingCell?: ReactNode;
};

type ProcessDataRowProps = {
  progress: IWorkOrderPOProgressModel;
  note: string;
  leadingCell?: ReactNode;
  onEdit: () => void;
  editAccessPermission: string[];
};

const ProcessDataRow = ({
  progress,
  note,
  leadingCell,
  onEdit,
  editAccessPermission,
}: ProcessDataRowProps) => {
  const lossAmount = progress?.lossAmount ?? progress?.lossAmountFECalc ?? 0;
  const lossPercent = progress?.lossPercent ?? progress?.lossPercentFECalc ?? 0;

  return (
    <TableRow>
      <TableCell>
        <Stack direction="row" spacing={1} alignItems="center">
          {leadingCell}
          <EditIconButton
            accessPermission={editAccessPermission}
            onClick={onEdit}
          ></EditIconButton>
        </Stack>
      </TableCell>
      <TableCell>{dateTimeDisplay(progress?.date) || ""}</TableCell>
      <TableCell>
        <NumberText value={progress?.amount || 0}></NumberText>
      </TableCell>
      <TableCell>{progress?.equipment || ""}</TableCell>
      <TableCell>{progress?.operator || ""}</TableCell>
      <TableCell>{progress?.inspector || ""}</TableCell>
      <TableCell>{dateTimeDisplay(progress?.completedDate) || ""}</TableCell>
      <TableCell>
        <NumberText value={progress?.completedAmount || 0}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={lossAmount}></NumberText>
      </TableCell>
      <TableCell>
        <NumberText value={lossPercent}></NumberText>
      </TableCell>
      <TableCell>{note}</TableCell>
    </TableRow>
  );
};
export const StandardProcessTable = ({
  standardTitle,
  departmentTitle,
  progress,
  note,
  onEdit,
  editAccessPermission,
  leadingCell,
  orderNumber,
}: StandardProcessTableProps) => {
  return (
    <OrderNumberBadge orderNumber={orderNumber}>
      <XTablePagination hidePagination>
        <TableHead>
          <TableRow>
            <TableCell align="center" rowSpan={2}>
              {standardTitle}
            </TableCell>
            <TableCell align="center" colSpan={9}>
              {departmentTitle}
            </TableCell>
            <TableCell align="center" rowSpan={2}>
              Ghi Chú Sản Xuất
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Ngày S/X</TableCell>
            <TableCell>Số Lượng S/X</TableCell>
            <TableCell>Thiết Bị S/X</TableCell>
            <TableCell>Người S/X</TableCell>
            <TableCell>Người Kiểm QT</TableCell>
            <TableCell>Ngày H/T</TableCell>
            <TableCell>Số Lượng H/T</TableCell>
            <TableCell>Hao Hụt</TableCell>
            <TableCell>Tỉ Lệ %</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ProcessDataRow
            progress={progress}
            note={note}
            leadingCell={leadingCell}
            onEdit={onEdit}
            editAccessPermission={editAccessPermission}
          ></ProcessDataRow>
        </TableBody>
      </XTablePagination>
    </OrderNumberBadge>
  );
};
